import HolidayOrPolicyView from './HolidayOrPolicyView';
export default HolidayOrPolicyView;
